import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = {
  key: 0,
  class: "filter-site-container"
}
const _hoisted_6 = { class: "radio-container" }
const _hoisted_7 = { class: "span-container" }
const _hoisted_8 = { class: "dataTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_RadioBox = _resolveComponent("RadioBox")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_ModalDownloadDocuments = _resolveComponent("ModalDownloadDocuments")!
  const _component_ModalChoixNomZip = _resolveComponent("ModalChoixNomZip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.displayModalChoixSite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('rapports.intervention.title')) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "rapportsIntervention.definition" })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.isUniqueSite)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.filter')) + " ", 1),
                    _createVNode(_component_ButtonBlue, {
                      "on-click": _ctx.selectionnerSite,
                      text: _ctx.$t('bouton.choix.site'),
                      class: "button-confirm btn",
                      disabled: _ctx.tableData.length === 0 && _ctx.isLoading || _ctx.filtreEquipementLoading || _ctx.filtreGroupeLoading
                    }, null, 8, ["on-click", "text", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_RadioBox, { selected: _ctx.isPreventif }, null, 8, ["selected"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('document.rapports.intervention.preventive.radio')), 1)
              ]),
              _createVNode(_component_Filter, {
                onSearch: _ctx.doFilter,
                onSetDocumentDateFrom: this.setDocumentDateFrom,
                onSetDocumentDateTo: this.setDocumentDateTo,
                onAddFilterGroupe: this.addFilterGroupe,
                onAddFilterSousGroupe: this.addFilterSousGroupe,
                onRemoveFilterGroupe: this.removeFilterGroupe,
                onRemoveFilterSousGroupe: this.removeFilterSousGroupe,
                onAddFilterEquipement: this.addFilterEquipement,
                onRemoveFilterEquipement: this.removeFilterEquipement,
                onClearFilter: this.clearFilter,
                onGroupeToggleSelectAll: this.groupeToggleSelectAll,
                onEquipementToggleSelectAll: this.equipementToggleSelectAll,
                onSousGroupeToggleSelectAll: this.sousGroupeToggleSelectAll,
                sousGroupeList: this.sousGroupeList,
                filter: this.filter,
                groupeList: this.groupeList,
                equipementList: this.equipementListFiltered,
                searchSite: _ctx.searchSite,
                class: "filter"
              }, null, 8, ["onSearch", "onSetDocumentDateFrom", "onSetDocumentDateTo", "onAddFilterGroupe", "onAddFilterSousGroupe", "onRemoveFilterGroupe", "onRemoveFilterSousGroupe", "onAddFilterEquipement", "onRemoveFilterEquipement", "onClearFilter", "onGroupeToggleSelectAll", "onEquipementToggleSelectAll", "onSousGroupeToggleSelectAll", "sousGroupeList", "filter", "groupeList", "equipementList", "searchSite"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", null, [
                  _createTextVNode(_toDisplayString(_ctx.$tc('rapports.intervention.dataTable.title', +_ctx.count)) + " ", 1),
                  _createVNode(_component_ReglePastille, { cle: "rapportsIntervention.portee" }),
                  _createVNode(_component_ReglePastille, { cle: "rapportsIntervention.filtresEnCascade" })
                ]),
                _createElementVNode("div", null, [
                  (!_ctx.isDownloadDisabled)
                    ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                        key: 0,
                        onClick: _ctx.getDocuments,
                        class: "button-left",
                        imgUrl: _ctx.iconeDownload,
                        title: _ctx.$t('list.download.selection')
                      }, null, 8, ["onClick", "imgUrl", "title"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ReglePastille, { cle: "rapportsIntervention.telechargementGroupe" }),
                  (_ctx.isAtLeastOneReport)
                    ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                        key: 1,
                        onClick: _ctx.downloadAllDocuments,
                        imgUrl: _ctx.iconeDownload,
                        title: _ctx.$t('list.download.all'),
                        class: "button-right"
                      }, null, 8, ["onClick", "imgUrl", "title"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ReglePastille, { cle: "rapportsIntervention.telechargerTout" })
                ])
              ]),
              (_ctx.tableData.length === 0 && _ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                    key: 0,
                    class: "loader"
                  }))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    ref: "content",
                    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                    class: "datatable-container-smaller"
                  }, [
                    _createVNode(_component_DataTable, {
                      tableData: this.tableData,
                      isLoading: _ctx.isLoading,
                      tableHeader: this.tableHeader,
                      noDataText: _ctx.$t('search.notFound'),
                      documentListToDownload: _ctx.documentListToDownload,
                      onSort: _ctx.doSort,
                      onSelect: _ctx.doSelect
                    }, null, 8, ["tableData", "isLoading", "tableHeader", "noDataText", "documentListToDownload", "onSort", "onSelect"])
                  ], 544))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_ModalChoixSite, {
          key: 1,
          onCancel: _ctx.modalChoixSiteCancel,
          onValider: _ctx.validerSite,
          "selected-site": null,
          "selected-sites": _ctx.filter.siteList,
          "is-multi-site": true,
          "inclure-termines": true
        }, null, 8, ["onCancel", "onValider", "selected-sites"])),
    (_ctx.isZipLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.showModalDownloadAll)
      ? (_openBlock(), _createBlock(_component_ModalDownloadDocuments, {
          key: 3,
          onCancel: _ctx.cancelModalDownloadAll,
          onDownloadDocuments: _ctx.setFilterForDownloadAllDocuments,
          "nb-documents-modal": _ctx.getNbRapports
        }, null, 8, ["onCancel", "onDownloadDocuments", "nb-documents-modal"]))
      : _createCommentVNode("", true),
    (_ctx.showModalNomZip)
      ? (_openBlock(), _createBlock(_component_ModalChoixNomZip, {
          key: 4,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalNomZip = false)),
          onDownload: _ctx.downloadDocuments
        }, null, 8, ["onDownload"]))
      : _createCommentVNode("", true)
  ], 64))
}